// LocalStorage-backed favourites for logged-out and logged-in users.
// Keeps things simple: no DB writes, no server round-trip — just per-device.
// Emits a "favorites:changed" event so React components can re-render.

const KEY = "acresdeal.favorites";

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch { return []; }
}

function write(ids) {
  try {
    localStorage.setItem(KEY, JSON.stringify(Array.from(new Set(ids))));
    window.dispatchEvent(new Event("favorites:changed"));
  } catch { /* noop */ }
}

export function getFavoriteIds() {
  return read();
}

export function isFavorite(id) {
  return read().includes(id);
}

export function toggleFavorite(id) {
  const cur = read();
  const next = cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id];
  write(next);
  return next.includes(id);
}

export function removeFavorite(id) {
  write(read().filter((x) => x !== id));
}
